export default __webpack_public_path__ + "static/pod-icon-2f666dc633dbcb1089a7f5d7f1afa50d.png";